/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, DestroyRef, OnInit, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AUTHENTICATION_PROVIDER} from '../../../services/authentication/authentication-provider.token';

export type ErrorPageDetail = {
  errorCode: string;
  errorHeader: string;
  errorDescription: string;
};

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  standalone: false,
})
export class ErrorComponent implements OnInit {
  private readonly auth = inject(AUTHENTICATION_PROVIDER);
  private readonly destroyRef = inject(DestroyRef);

  errorDetail: ErrorPageDetail = {
    errorCode: '404',
    errorHeader: 'error.header.not_found',
    errorDescription: 'error.description.not_found',
  };

  ngOnInit(): void {
    this.auth.error$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(async (error) => {
        if (!error) {
          return;
        }
        this.errorDetail = await this.createErrorObject(error.message);
      });
  }

  async createErrorObject(errorDescription: string): Promise<ErrorPageDetail> {
    if (
      errorDescription &&
      errorDescription.includes(
        'Potential Violation Detected! The email/domain may present export control compliance risks.',
      )
    ) {
      return {
        errorCode: '403',
        errorHeader: 'error.header.email_domain_export_control',
        errorDescription: 'error.description.email_domain_export_control',
      };
    } else {
      return {
        errorCode: '404',
        errorHeader: 'error.header.not_found',
        errorDescription: 'error.description.not_found',
      };
    }
  }
}
